export default __webpack_public_path__ + "5b4f531ec1076a54baed605a65616276.svg";